import { Stack, Typography } from "@mui/material";
import { DEFAULT_TIME_ZONE } from "constant";
import { useRouteLoaderData } from "react-router-dom";
import { User } from "type/model/api";
import { AssetView } from "type/model/view";
import { currentShift, shiftLabel } from "utility/shift";

interface Props {
  asset?: AssetView | undefined;
}

export const AssetIdentifier = ({ asset }: Props) => {
  const { currentUser } = useRouteLoaderData("main") as { currentUser: User };

  if (!asset) {
    return <>No asset assigned</>;
  }

  const shift = shiftLabel(currentShift(asset.shifts), currentUser.time_zone || DEFAULT_TIME_ZONE);

  return (
    <Stack sx={{ whiteSpace: "nowrap" }}>
      <Typography variant="body2">{asset.name}</Typography>
      {asset.callSign ? <Typography variant="body2">{asset.callSign}</Typography> : null}
      {asset.registration ? <Typography variant="body2">{asset.registration}</Typography> : null}
      {shift ? <Typography variant="body2">{shift}</Typography> : null}
    </Stack>
  );
};
